module.exports = __webpack_public_path__ + "img/1.649417c7.png";